module.exports = __webpack_public_path__ + "img/34.2679efe0.png";